import { OEButton } from '@openeducation/oe-rn-components';
import React from 'react';
import { Linking } from 'react-native';

export const LiveClassLessonDownloadButton = ({ url }: { url?: string }) => {
  const handleDownload = () => url && Linking.openURL(url);

  return (
    <OEButton
      type="accent"
      mode="outlined"
      icon="download"
      disabled={!url}
      onPress={handleDownload}
    >
      Download material
    </OEButton>
  );
};
